import React from "react";

import BotAvatar from "./images/ISicon1.png";
// import bot from "./images/bot.png";
// import { useSelector } from "react-chatbot-kit";

const CoBotAvatar = (props) => {
  const isTyping = props.state?.isTyping;
  // console.log("🤖 CoBotAvatar isTyping:", isTyping);
  return (
    <div className="react-chatbot-kit-chat-bot-avatar">
      <div
        className={"react-chatbot-kit-chat-bot-avatar-container " + (isTyping ? "typing-glow" : "")}
        style={{ 
          // background: loading ? "rgba(0, 115, 230, 0.3)" : "none",
          // border: loading ? "2px solid #0073e6" : "none"
        }}
      >
        <img alt="BotAvatar" src={BotAvatar}  style={{width: '100%', height: '100%', borderRadius: '50%',transition: 'all 0.5s ease-in-out'}}/>
      </div>
    </div>
  );
};

export default CoBotAvatar;
